import { render, staticRenderFns } from "./NovoSeguro.vue?vue&type=template&id=421ea52e&scoped=true"
import script from "./NovoSeguro.vue?vue&type=script&lang=js"
export * from "./NovoSeguro.vue?vue&type=script&lang=js"
import style0 from "./NovoSeguro.vue?vue&type=style&index=0&id=421ea52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ea52e",
  null
  
)

export default component.exports